import { useSafeTranslation } from 'shared/i18n';

import emailSent from '../../assets/email-sent.svg';
import styles from './Email.module.scss';

type EmailSentConfirmationViewProps = {
  email: string;
  onResendVerification: () => void;
};

export const EmailSentConfirmationView = ({
  email,
  onResendVerification,
}: EmailSentConfirmationViewProps) => {
  const { t } = useSafeTranslation();

  return (
    <div className={styles.container}>
      <div className="p-body">
        <img className="mb16" src={emailSent} alt="Email sent" />
        <h1 className="p-h1">
          {t('updateEmail.emailSentConfirmation.title', 'Check your inbox')}
        </h1>
        <div className="p-p mt8">
          {t(
            'updateEmail.emailSentConfirmation.subtitle',
            'We’ve sent a verification link to'
          )}{' '}
          <span className="fw-bold">{email}</span>
        </div>
        <button
          className="ds-interactive-component p-a fw-bold mt8"
          onClick={onResendVerification}
          type="button"
        >
          {t(
            'updateEmail.emailSentConfirmation.resendVerificationEmail',
            'Resend verification email'
          )}
        </button>
      </div>
    </div>
  );
};
